<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="配送方式管理" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button
								size="mini"
								type="primary"
								@click="handleCreate()"
								v-loading="loadings.create"
								>新建</el-button
							>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
			v-if="editorVisible"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";

export default {
	mixins: [CurdPage],

	data() {
		return {
			editorDataModel: "Distribution",
			tableFields: [
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "name_front",
				},
				{
					name: "send_time",
				},
				{
					name: "express_time",
				},
				{
					name: "desc",
				},
				{
					name: "type",
				},
				{
					name: "express_fee",
				},
				{
					name: "clearance_fee",
				},
				{
					name: "multi_ratio",
				},
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					width: "100%",
				},
				{
					name: "name_front",
				},
				{
					name: "send_time",
				},
				{
					name: "express_time",
				},
				{
					name: "desc",
					width: "100%",
				},
				{
					name: "type",
					col: 6,
				},
				{
					name: "express_fee",
					col: 6,
				},
				{
					name: "clearance_fee",
					col: 6,
				},
				{
					name: "multi_ratio",
					col: 6,
				},
			],
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	watch: {},
	components: {},
};
</script>
<style lang="scss" scoped></style>
